<template>
  <div>
    <div class="row justify--space-between align--center ma-0 mb-4">
      <h1 :style="{color: $themes.primary, textTransform: 'uppercase'}">{{ title }}</h1>
      <va-button @click="() => $router.push({ name: 'new-category' })" class="ma-0">{{ $t('category.new') }}</va-button>
    </div>

    <data-table-categories class="mb-4"/>
  </div>
</template>

<script>
import DataTableCategories from '../components/DataTableCategories.vue'

export default {
  data: () => ({
    title: 'Categorias',
  }),
  components: {
    DataTableCategories,
  },
}
</script>
